import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AlertsService } from '../../services/alerts.service';
import { UtilService } from '../../services/util.service';
import { AppService } from '../../shared/services/app.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { PopupFormComponent } from '../popupform/popupform.component';

@Component({
    selector: 'dhs-pushable',
    templateUrl: './pushable.component.html',
    styleUrls: ['./pushable.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PushableComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PushableComponent implements OnInit {
  @Input() question: any;
  @Input('value') _value = false;
  @Output() valueChange = new EventEmitter<any>();
  @Input() bannerJson: any;
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  dataGridConfig = {
    "viewAll": true,
    "hideSearchBox": true,
    "hideResult": false,
    "customButtonsAllowed": false,
    "allowPagination": false,
  };
  fields: any = [];
  action_source: any;
  vitalData: any = {};
  diagnosis_data: any
  editButtonPushableList = ["condition_diagnosis_main"]// add pushable resource for show edit button 
  isView: boolean = false;

  constructor(public dialogService: DialogService,
    public baseService: BaseService,
    public utilService: UtilService,
    public alerts: AlertsService,
    public app: AppService) { }

  ngOnInit() {
    if (this.dataGridConfig && this.dataGridConfig['refreshOnFieldsChange'] != undefined) {
      delete this.dataGridConfig['refreshOnFieldsChange'];
    }
    if (this.question.pushable_master && this.question.pushable_master.frontend_resource) {
      if (this.question.pushable_master.frontend_resource == 'app-vitals-view') {
        this.dataGridConfig['refreshOnFieldsChange'] = true;
        if (this.question.value != 0) {
          this.vitalData = JSON.parse(this.question.value);
          this.vitalData.isEmpty = true;
          this.vitalData.list = {
            fields: [],
            value: {}
          };
          this.vitalData.vitalsName.forEach((res, i) => {
            this.vitalData.list['fields'].push({
              "heading": res.name,
              "order": i + 1,
              "name": res.name
            })
          })
          this.vitalData.vitalsName.forEach(vital => {
            this.vitalData.list.value[vital.name] = vital.value
          })
          this.vitalData.list['fields'].push({
            "heading": "Action",
            "order": this.vitalData.list.fields.length,
            "sortable": false,
            "class_name": "freeze",
            "name": "",
            "config": {
              "type": this.utilService.isMobile() ? "ellipse" : "button",
              "buttonMenu": [{
                "key": "id",
                "action": "delete",
                "icon": "fa fa-trash",
                "label": ""
              }]
            }
          })
          this.fields = this.vitalData.list.fields;
        }
      } else {
        this.baseService.getResourceDef(this.question.pushable_master.frontend_resource, (resouceDef) => {
          if (resouceDef) {
            if (!this.baseService?.router?.routerState.snapshot.url.includes("view_clm_package_summary"))
              resouceDef.list && resouceDef.list['fields'] && resouceDef.list['fields'].push({
                "heading": "Action",
                "order": resouceDef.list.fields.length,
                "sortable": false,
                "class_name": "freeze",
                "name": "",
                "config": {
                  "type": this.utilService.isMobile() ? "ellipse" : "button",
                  "buttonMenu": [
                    {
                      "key": "id",
                      "action": "delete",
                      "icon": "fa fa-trash",
                      "label": ""
                    }
                  ]
                }
              })
            if (this.checkEditButtonPushable() && this.baseService?._resourceName == "discharge_summary") {
              let lastField = resouceDef.list['fields'][resouceDef.list.fields.length - 1];
              if (lastField.config && lastField.config.buttonMenu) {
                lastField.config.buttonMenu.push({
                  "key": "id",
                  "action": "modify",
                  "icon": "fa fa-pencil",
                  "label": ""
                });
              }
            }
            this.fields = resouceDef.list.fields;
          }
        });
      }

      if (this.baseService?.router?.routerState.snapshot.url.includes("view_clm_package_summary")) {
        this.isView = true;
      }
    }
  }

  openModalPopup() {
    if (sessionStorage && sessionStorage.currentData)
      var currentData = JSON.parse(sessionStorage.currentData);
    this.action_source = this.question.pushable_master;
    let obj = {
      "tempType": "pushable",
      "layout_type": "simple",
      "resource": currentData && (currentData.patientType == 'OP' || currentData.patientType == 'HC') && this.action_source.frontend_resource == 'condition_diagnosis_main' ? 'op_diagnosis' : this.action_source.frontend_resource,
      "application": this.action_source.application_id,
      "action": "ADD",
      "layout_column": "one-column",
      "getdata": true,
      "size": this.action_source.meta_data == 'COMPOSITE-ARRAY' ? DialogModalSize.Md : DialogModalSize.Sm,
      banner: this.bannerJson,
      "medication_order_type": this.question.pushable_master && this.question.pushable_master.frontend_resource == "pushable_medication_order" && this.question.gridData && this.question.gridData.length > 0 && this.question.gridData[0].medication_order_type ? this.question.gridData[0].medication_order_type : "",//set for medication order
      "storeId": this.question.pushable_master && this.question.pushable_master.frontend_resource == "pushable_medication_order" && this.question.gridData && this.question.gridData.length > 0 && this.question.gridData[0].storeId ? this.question.gridData[0].storeId : "", //set for medication order
      "store": this.question.pushable_master && this.question.pushable_master.frontend_resource == "pushable_medication_order" && this.question.gridData && this.question.gridData.length > 0 && this.question.gridData[0].store ? this.question.gridData[0].store : "" //set for medication order
    };
    if (this.question['gridData'] == undefined)
      this.question['gridData'] = [];

    if (this.action_source && this.action_source.frontend_resource == 'pushable_clinical_order') {
      //134965
      var duplicateClinicalOrderConfig: any;
      this.baseService.get('GET_CONFIG', "config_code:order-104,module_code:order", 'facility_config_mapping', 'facility-management').subscribe(data => {
        if (data && data.resource && data.resource.length > 0) {
          if (data.resource[0].config_value != "No") {
            duplicateClinicalOrderConfig = data.resource[0].config_value
          }
        }
      })
    }
    if (this.action_source.meta_data == 'custom') {
      var component = this.app._factories.components[obj.resource];
      if (component) {
        this.dialogService.open(component, obj).afterClosed.subscribe(
          response => {
            console.log("check data===>", response);
            if (response && response.result) {
              response['fields'].push({
                "heading": "Action",
                "order": response.fields.length,
                "sortable": false,
                "class_name": "freeze",
                "name": "",
                "config": {
                  "type": this.utilService.isMobile() ? "ellipse" : "button",
                  "buttonMenu": [{
                    "key": "id",
                    "action": "delete",
                    "icon": "fa fa-trash",
                    "label": ""
                  }]
                }
              })
              console.log("resonse=>", response);
              if (Object.keys(response.result).length != 0) {
                /*for identify new added data in op prescription(reopen\addendum)*/
                if (sessionStorage && sessionStorage.getItem("temp_pres_version") != undefined) {
                  response.result['add_version'] = sessionStorage.getItem("temp_pres_version");
                }
                /******/
                this.fields = response.fields;
                this.question['gridData'] = [response.value];
                this.value = response.result;
                this.valueChange.emit(response.result);
              }
            }
          });
      }
    }
    else {
      this.dialogService.open(PopupFormComponent, obj).afterClosed.subscribe(
        response => {
          console.log("check data===>", response);
          //set pushable grid data
          if (response && response.result) {
            /********** check null **********/
            // if (response.result.checkNull) {
            //   Object.keys(response.result).every(elem => {
            //     if (response.result[elem] == null) {
            //       response.result = {};
            //       this.alerts.error("Due to null " + elem + ", Remove entry please add again");
            //       return false;//break
            //     } else return true;//again check
            //   });
            // }
            /*******************************/
            /*for identify new added data in op prescription(reopen\addendum)*/
            if (Object.keys(response.result).length != 0 && sessionStorage && sessionStorage.getItem("temp_pres_version") != undefined) {
              response.result['add_version'] = sessionStorage.getItem("temp_pres_version");
            }
            /********/
            if (this.action_source.meta_data == 'COMPOSITE-ARRAY' && Object.keys(response.result).length != 0) {
              if (this.action_source.frontend_resource == 'pushable_cathlab_surgery_request' || this.action_source.frontend_resource == 'pushable_surgery_request') {
                var Arr = response.result.surgery_request_details;
              } else {
                var Arr = (response.result.data == undefined && this.action_source.frontend_resource == 'pushable_clinical_order') ? response.result.services : response.result.data;
              }

              if (this.action_source.frontend_resource == 'pushable_clinical_order' && (this.baseService?._resourceName == "template_assessment" || this.baseService?._resourceName == "progress_note")) {
                const correlationId = this.getPushableCorelationId();
                if (Arr && Array.isArray(Arr)) {
                  Arr.forEach(item => {
                    if (item && !item.pushable_corelation_id) {
                      item.pushable_corelation_id = correlationId;
                    }
                  });
                }
              }

              /********** check null **********/
              // if (Arr[0].checkNull) {
              //   let indexArr = [];
              //   for (let i = 0; i < Arr.length; i++) {
              //     for (let j = 0; j < Object.keys(Arr[i]).length; j++) {
              //       if (Arr[i][Object.keys(Arr[i])[j]] == null) {
              //         indexArr.push(i);
              //         break;
              //       }
              //     }
              //   }
              //   if (indexArr.length > 0)
              //     for (var i = indexArr.length - 1; i >= 0; i--) {
              //       Arr.splice(indexArr[i], 1);
              //       this.alerts.error("Due to null value remove " + indexArr[i] + "th entry, please add again");
              //     }
              // }
              /*******************************/
              console.log("resonse=>", response, Arr);
              if (Arr && Arr.length > 0)
                for (let i = 0; i < Arr.length; i++) {
                  //check duplicate medication
                  if (this.question['gridData'] && this.question['gridData'].length > 0 && this.action_source.frontend_resource == "pushable_medication_order") {
                    let validObj = this.question['gridData'].filter(data => data['itemId'] == Arr[i]['itemId']);
                    if (validObj.length > 0) {
                      this.alerts.error("Duplicate Item", "Item already exists")
                    } else
                      this.question['gridData'].push(Arr[i]);
                  } else if (this.question['gridData'] && this.question['gridData'].length > 0 && this.action_source.frontend_resource == "pushable_clinical_order") {
                    let duplicateConfigCheck = duplicateClinicalOrderConfig?.includes(Arr[i]?.serviceType_code?.toLowerCase());
                    let validObj: any;
                    if (!duplicateConfigCheck)
                      validObj = this.question['gridData'].filter(data => data['serviceItemName'] == Arr[i]['serviceItemName']);

                    if (validObj != undefined && validObj.length > 0)
                      this.alerts.error("Duplicate Item", "Item already exists")
                    else
                      this.question['gridData'].push(Arr[i]);
                  }
                  else
                    this.question['gridData'].push(Arr[i]);
                }
            } else {
              this.checkExistingDiagnosis(response.result, cb => {
                if (cb != undefined) {
                  response.result = cb
                  if (Object.keys(response.result).length != 0) {
                    //follow up is pushed as a single record
                    if (this.action_source.frontend_resource == 'follow_up' && (this.baseService?._resourceName == "template_assessment" || this.baseService?._resourceName == "progress_note") && !response.result['pushable_corelation_id']) {
                      response.result['pushable_corelation_id'] = this.getPushableCorelationId();
                    }
                    this.question['gridData'].push(response.result)
                  }
                }
              })

            }
            if (this.question['gridData']) {
              this.question['gridData'] = [...this.question['gridData']];
            }
            this.value = this.question['gridData'];
            this.valueChange.emit(this.question['gridData']);
          }
        });
    }
  }

  modifyForm(event) {
    if (event.actionType && event.actionType.action === 'modify' && this.checkEditButtonPushable() && this.baseService?._resourceName == "discharge_summary") {
      this.action_source = this.question.pushable_master;
      let obj = {
        "tempType": "pushable",
        "layout_type": "simple",
        "resource": currentData && (currentData.patientType == 'OP' || currentData.patientType == 'HC') && this.action_source.frontend_resource == 'condition_diagnosis_main' ? 'op_diagnosis' : this.action_source.frontend_resource,
        "application": this.action_source.application_id,
        "action": "MODIFY",
        "layout_column": "one-column",
        "getdata": true,
        "data": event.data,
        "size": this.action_source.meta_data == 'COMPOSITE-ARRAY' ? DialogModalSize.Md : DialogModalSize.Sm,
        banner: this.bannerJson,
        "medication_order_type": this.question.pushable_master && this.question.pushable_master.frontend_resource == "pushable_medication_order" && this.question.gridData && this.question.gridData.length > 0 && this.question.gridData[0].medication_order_type ? this.question.gridData[0].medication_order_type : "" //set for medication order
      };
      this.dialogService.open(PopupFormComponent, obj).afterClosed.subscribe(
        response => {
          console.log("check data===>", response);
          //set pushable grid data
          if (response && response.result) {
            this.question['gridData'].splice(event.index, 1)
            this.checkExistingDiagnosis(response.result, cb => {
              if (cb != undefined) {
                if (Object.keys(response.result).length != 0)
                  this.question['gridData'].push(response.result)
              }
            })
            if (this.question['gridData']) {
              this.question['gridData'] = [...this.question['gridData']];
            }
            this.value = this.question['gridData'];
            this.valueChange.emit(this.question['gridData']);
          }
        });
    }
    else {
      console.log(event, 'event is:');
      if (sessionStorage && sessionStorage.currentData)
        var currentData = JSON.parse(sessionStorage.currentData);
      if (this.question && this.question.pushable_master && (this.question.pushable_master.frontend_resource == "pushable_medication_order" || this.question.pushable_master.frontend_resource == "pushable_clinical_order" || this.question.pushable_master.frontend_resource == "follow_up")) {
        var data: any;
        if (this.question.pushable_master.frontend_resource == "pushable_medication_order") {
          data = {
            "val": [{ "itemCode": event.data['itemCode'], "uhId": currentData.uhId, "encounter_id": currentData.encounter_id, "medication_order_type": event.data['medication_order_type'] }],
            "action": "DELETE_DISCHARGE_SUMMARY_MEDICINE",
            "resource": "medicationOrderDetails",
            "application": "pharmacy"
          }
        } else if (this.question.pushable_master.frontend_resource == "pushable_clinical_order") {
          data = {
            "val": {
              "serviceItemCode": event.data['serviceItemCode'],
              "uhId": currentData.uhId,
              "encounter_id": currentData.encounter_id,
              "order_screen": this.baseService._resourceName
            },
            "action": "CANCEL_PUSHABLE_ORDER",
            "resource": "service_request",
            "application": "order"
          }
          if (this.baseService?._resourceName == "template_assessment" || this.baseService?._resourceName == "progress_note") {
            data.val['pushable_corelation_id'] = event.data['pushable_corelation_id'];
            if (this.question['gridData'] && Array.isArray(this.question['gridData']) && this.question['gridData'].length == 1) {
              this.question.pushable_master['pushable_corelation_id'] = event.data['pushable_corelation_id'];
            }
          }
        } else if (this.question.pushable_master.frontend_resource == "follow_up") {
          data = {
            "val": {
              "id": event.data['id'],
              "uhId": currentData.uhId,
              "encounter_id": currentData.encounter_id
            },
            "action": "CANCELLED_FOLLOW_UP",
            "resource": "follow_up",
            "application": "emr"
          }
          if (this.baseService?._resourceName == "template_assessment" || this.baseService?._resourceName == "progress_note") {
            data.val['pushable_corelation_id'] = event.data['pushable_corelation_id'];
            if (this.question['gridData'] && Array.isArray(this.question['gridData']) && this.question['gridData'].length == 1) {
              this.question.pushable_master['pushable_corelation_id'] = event.data['pushable_corelation_id'];
            }
          }
        }
        this.baseService.action(data.val, data.action, data.application, data.resource).subscribe((res) => {
          if (res && res.errCode == 0) {
            this.alerts.success("Request Successful");
            this.removeRow(event);
          } else
            this.alerts.error(res.message);
        })
      } else
        this.removeRow(event);
    }

  }

  removeRow(event) {
    this.question.gridData.forEach((element, i) => {
      if (JSON.stringify(element) == JSON.stringify(event.data)) {
        this.question.gridData.splice(i, 1)
        if (this.question['gridData']) {
          this.question['gridData'] = [...this.question['gridData']];
        }
        this.value = this.question['gridData'];
        this.valueChange.emit(this.question['gridData']);
      }
    });
  }

  get value(): any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      if (value != '' && this.question?.isCopyTemplate == true && this.baseService?._resourceName != "discharge_summary") {
        value = [];//185806 in case copy template pushable should be set as blank for all temp type except discharge summay
        this.question['gridData'] = [];
      }
      this.value = value;
      if (typeof value == 'string') {
        if (this.question.pushable_master.frontend_resource == 'app-vitals-view') {
          if (this.question['gridData'] == undefined)
            this.question['gridData'] = [];
          if (this.vitalData.isEmpty) {
            this.question['gridData'].push(this.vitalData.list.value);
            this.vitalData.isEmpty = false;
          }
        } else {
          this.question.gridData = JSON.parse(value);
        }
      }

      if ((this.question?.pushable_master?.frontend_resource == 'pushable_clinical_order' || this.question?.pushable_master?.frontend_resource == 'follow_up') && this.question['gridData'] && Array.isArray(this.question['gridData']) && (this.baseService?._resourceName == "template_assessment" || this.baseService?._resourceName == "progress_note")) {
        const correlationId = this.getPushableCorelationId();
        this.question['gridData'].forEach(item => {
          if (item && !item.pushable_corelation_id) {
            item.pushable_corelation_id = correlationId;
          }
        });
        if (typeof value == 'string') {
          this.value = JSON.stringify(this.question['gridData']);
        } else {
          this.value = this.question['gridData'];
        }
      }

    } else {
      this.value = ""
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  checkEditButtonPushable() {
    const frontendResource = this.question?.pushable_master?.frontend_resource;
    if (this.editButtonPushableList.includes(frontendResource)) {
      if (frontendResource === 'condition_diagnosis_main' && this.question.value != undefined && this.question.value != null && this.question.value != '') {
        const questionValue = Array.isArray(this.question.value) ? this.question.value : JSON.parse(this.question.value);
        if (questionValue[0]?.hasOwnProperty('isFinal')) {
          const isFinal = questionValue[0].isFinal;
          if (isFinal === null || isFinal === '') {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  }

  //the first pushable keeps it in session, every other pushable of that screen reuses it
  getPushableCorelationId() {
    let existingCorrelationId = '';
    if (this.question['gridData'] && Array.isArray(this.question['gridData'])) {
      const existingItem = this.question['gridData'].find(item => item && item.pushable_corelation_id);
      if (existingItem) {
        existingCorrelationId = existingItem.pushable_corelation_id;
      }
    }
    const sessionKey = 'pushable_corelation_id_' + this.baseService?._resourceName;
    const correlationId = existingCorrelationId
      || this.question?.pushable_master?.['pushable_corelation_id']
      || (sessionStorage ? sessionStorage.getItem(sessionKey) : '')
      || crypto.randomUUID();
    if (sessionStorage) {
      sessionStorage.setItem(sessionKey, correlationId);
    }
    return correlationId;
  }

  checkExistingDiagnosis(currentRowData?, cb?) {
    const hasDiagnosis = this.question['gridData']?.filter(item => item.diagnosis?.length > 0).length > 0;
    if (hasDiagnosis && this.question['gridData']) {
      const arr = JSON.parse(JSON.stringify([currentRowData]));
      this.question['gridData'].forEach(gridItem => {
        if (gridItem.diagnosis) {
          gridItem.diagnosis.forEach(diagnosis => {
            arr.forEach(element => {
              const existingDiagnosis = element.diagnosis.find(item => item.id === diagnosis.id);
              const indexToRemove = currentRowData['diagnosis'].findIndex(data => data.id === diagnosis.id);
              if (existingDiagnosis && indexToRemove !== -1) {
                currentRowData['diagnosis'].splice(indexToRemove, 1);
                this.alerts.error(`${diagnosis.text} already exists`);
              }
            });
          });
        }
      });
      if (currentRowData.diagnosis.length) {
        cb(currentRowData);
      }
    } else {
      cb(currentRowData);
    }
  }





}
